import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { useNavigate } from "react-router";
import { TopBar } from "../../../shared/topBar/TopBar";
import { useDispatch, useSelector } from "react-redux";
import { getMarketDataDetails } from '../../../actions/marketDataAction';
import { UrlPath } from "../../../../config/routeConfig";
import { SBADropDown } from "../../../UiComponents/SBADropDown";
import { ToastContainer, toast } from 'react-toastify';
import { getStrategy } from "../../../actions/assetDetailsActions";
import { insertorUpdateMarketData, deleteMarketData,getEnumerations } from "../../../../config/apiConfig";
import { getDataSource, getEnumeration } from '../../../actions/CommonAction';
import $ from "jquery";
import { Modal } from 'react-bootstrap';
import { sbaAxios } from "../../../utils/sbaAxios";
import { SBNotify } from "../../../utils/sbNotify";
export const MarketDataEdit = () => {

  const params = useParams();
  const history = useNavigate();


  const Level = [
    { BreadCrumb: "Market Data >", Routes: `${UrlPath.MarketData}` },
    { BreadCrumb: " Market Data Details >", Routes: `${UrlPath.MarketDataDetails}${params.MarketIndexId}` },
    { BreadCrumb: "Edit", Routes: `${UrlPath.MarketDataEdit}${params.MarketIndexId}` },
  ];
  const Gstate = useSelector(state => { return state; }) || {};
  const isEditable = Gstate.authorizationData.isEditable;

  const dispatch = useDispatch();
  const marketIndexId = params.MarketIndexId ? params.MarketIndexId : 29643;
  const Marketdatadetails = Gstate.Marketdata.Marketdatadetails || [];
  const Strategy = Gstate.strategy.strategy;
  const Enumerationdata = Gstate.enumValues.enumValues || [];
  const [selectedMarketName, setselectedMarketName] = useState();
  const [selectedMarketSymbol, setselectedMarketSymbol] = useState();
  const [selectedStrategy, setSelectedStrategy] = useState();
  const [selectedStrategyId, setSelectedStrategyId] = useState();
  const [selectedDS, setSelectedDS] = useState();
  const [selectedDSId, setSelectedDSId] = useState();
  const [selectedNotes, setSelectedNotes] = useState();
  const [selectedprimary, setSelectedPrimary] = useState();
  const DataSource = Gstate.DataSourcelist.DataSourcelist || [];
  const [showdeleteModal, setshowDeleteModal] = useState(false);
  const [selectedenum, setSelectedEnum] = useState();
  const [selectedenumId, setSelectedEnumId] = useState();
  const[reportingGroup,setReportingGroup]=useState();
  const[selectedreportingGroup,setSelectedReportingGroup]=useState();
  useEffect(() => {
    dispatch(getStrategy());
    dispatch(getMarketDataDetails(marketIndexId));
    dispatch(getDataSource(3));
    dispatch(getEnumeration("MarketIndexType"));
    getReportingGroup();
  }, []);
  const strategyDropdownChange = (e) => {
    setSelectedStrategy(e.value);
    setSelectedStrategyId(e.value.ClassificationId);
  };
  const marketNameChange = (event) => {
    setselectedMarketName(event.target.value);
  };
  const shortNameChange = (event) => {
    setselectedMarketSymbol(event.target.value);
  };
  const dsChange = (e) => {
    setSelectedDS(e.value);
    setSelectedDSId(e.value.DataSourceId);

  };

  const NotesChange = (event) => {
    setSelectedNotes(event.target.value);

  };
  const chkChange = () => {
    const primary = $("#chktype").prop("checked");
    setSelectedPrimary(primary);

  };
  const enumOnchange = (e) => {

    setSelectedEnum(e.value);
    setSelectedEnumId(e.value.EnumValue);
  };

  useEffect(() => {
    setSelectedStrategy({ ClassificationId: Marketdatadetails?.StrategyId === 0 ? null : Marketdatadetails?.StrategyId, ClassificationValue: Marketdatadetails?.StrategyName === "" ? "--Please Select--" : Marketdatadetails?.StrategyName })
    setSelectedDS({ DataSourceId: Marketdatadetails?.DataSourceId, DataSourceName: Marketdatadetails?.DataSourceName })
    setselectedMarketName(Marketdatadetails?.MarketIndexName);
    setselectedMarketSymbol(Marketdatadetails?.MarketIndexShortName);
    setSelectedPrimary(Marketdatadetails?.IsPrimary);
    setSelectedNotes(Marketdatadetails?.IndexNotes);
    setSelectedDSId(Marketdatadetails?.DataSourceId);
    setSelectedStrategyId(Marketdatadetails?.StrategyId);
    setSelectedEnumId(Marketdatadetails?.MarketIndexTypeId)
    setSelectedEnum({ EnumValue: Marketdatadetails?.MarketIndexTypeId, EnumName: Marketdatadetails?.MarketIndexType })
    setSelectedReportingGroup({EnumValue: Marketdatadetails?.ReportingGroupId, EnumName: Marketdatadetails?.ReportingGroupName})
  }, [])

  const cancelnavigate = () => {
    history(`${UrlPath.MarketDataDetails}${params.MarketIndexId}`);
  }

  //-- Edit  Market Details--
  const editMarketDataDetails = (event) => {
    event.preventDefault();
    let saveSuccess = true;
    let errorMsg = [];
    // Prepare the data to be sent in the POST request
    const data = {
      "MarketIndexId": Marketdatadetails?.MarketIndexId,
      "MarketIndexName": selectedMarketName,
      "MarketIndexShortName": selectedMarketSymbol,
      "DataSourceId": selectedDSId,
      "MarketIndexTypeId": selectedenumId,
      "IsPrimary": selectedprimary,
      "ConstituentId": selectedreportingGroup.EnumValue||0,
      "StrategyId": selectedStrategyId,
      "IndexNotes": selectedNotes,
      "ModifiedBy": 38
    };
    if (!selectedMarketName) {
      saveSuccess = false;
      errorMsg.push("Please Enter Market Name");
    }
    if (!selectedMarketSymbol) {
      saveSuccess = false;
      errorMsg.push("Please Enter Market Symbol");
    }

    if (saveSuccess) {
      sbaAxios({
        url: `${insertorUpdateMarketData}`,
        method: 'post',
        data: data,
      })
        .then((response) => {
          if (response === -2999) {
            toast.error('Market Data cannot be saved because name or Symbol is not unique.', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })

          }
          else {
            toast.success('Market Data Updated Successfully', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
            setTimeout(() => {
              dispatch(getMarketDataDetails(marketIndexId));
              history(`${UrlPath.MarketDataDetails}${params.MarketIndexId}`);
            }, 1000);
          }
        })

        .catch((error) => {
          console.error(error);
        });
    }
    else {
      let ErrorString = "";
      errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
      console.log(errorMsg);
      toast.error(ErrorString, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    }
  };
  const DeleteModalShow = () => {
    setshowDeleteModal(true);
  }

  const DeleteMarketData = () => {
    sbaAxios({
      url: `${deleteMarketData}${params.MarketIndexId}`,
      method: 'get',
    }).then((response) => {
      setshowDeleteModal(false);
      SBNotify({ Msg: "Market Data Deleted Successfully", type: 'success' });
      setTimeout(() => {
        history(`${UrlPath.MarketData}`);
      }, 1000);
    })
      .catch(error => {
        console.error('Error deleting data:', error);
      });
  }
  const closedeleteModal = () => {
    setshowDeleteModal(false);
  }
  const getReportingGroup = async () => {
    try {
        const response = await sbaAxios({
            url: `${getEnumerations}${'Reporting Group'}`,
            method: 'get',
        });
        setReportingGroup(response);
    } catch (error) {
        console.error("Error fetching Reporting Group from API:", error);
    }
};
       
const ReportingGroupddChange=(e)=>
{
  setSelectedReportingGroup(e.value);
}
  return (
    <div>
      <TopBar label={"Market Data Edit"} />
      <BreadCrumbs Levels={Level} />
      <div id="content" class="asset-detail-screen mainContentData">
        <div class="p-4">
          <div class="d-flex align-items-center justify-content-between my-2 flex-wrap flex-lg-nowrap">
            <div class="d-flex gap-2 align-items-center">
              <h2 class="fw-medium fs-6 m-0">{Marketdatadetails?.MarketIndexName}</h2>
            </div>
            <div>
            </div>
          </div>
          <div id="manfield" className="p-3 life-science rounded">
            <div className="row ">
              <div className="col-md-4">
                <div className="my-4">
                  <label className="label">Name<span className="mandatory">*</span></label>
                  <input
                    className="form-control w-75"
                    type="text"
                    Value={
                      Marketdatadetails?.MarketIndexName
                    }
                    onChange={marketNameChange}
                  />
                </div>
                <div className="my-1">
                  <label className="label">Symbol<span className="mandatory">*</span></label>
                  <input
                    className="form-control w-75"
                    type="text"
                    Value={Marketdatadetails?.MarketIndexShortName}
                    onChange={shortNameChange}
                  />
                </div>
                <div className="my-4">
                  <label className="label">Type</label>
                  <div>
                    <div className="d-flex gap-3">
                      <SBADropDown className="w-75" textField={"EnumName"}
                        valueField={"EnumValue"} data={Enumerationdata} onChange={enumOnchange} value={selectedenum}></SBADropDown>
                    </div>
                  </div>
                </div>
                <div className="my-4">
                  <label className="label">Data source</label>
                  <div>
                    <SBADropDown
                      className="w-75"
                      value={selectedDS}
                      data={DataSource}
                      textField={"DataSourceName"}
                      valueField={"DataSourceId"}
                      onChange={dsChange}
                    />

                  </div>

                </div>
                <div className="my-4">
                  <label style={{ display: 'flex', alignItems: 'center' }}>
                    <input className="me-1"
                      type="checkbox" id="chktype"
                      defaultChecked={Marketdatadetails?.IsPrimary}
                      onChange={chkChange}
                    />
                    <span>Primary</span>
                  </label>
                </div>
                <div className="my-4">
                  <label className="label">Strategy </label>
                  <div>
                    <SBADropDown
                      className='w-75'
                      value={
                        selectedStrategy
                      }
                      textField={"ClassificationValue"}
                      valueField={"ClassificationId"}
                      data={Strategy}

                      onChange={strategyDropdownChange}
                    />
                  </div>
                </div>
                <div className="my-4">
                      <label className="label">Reporting Group </label>
                        <div>
                        <SBADropDown
                                className='w-75'
                                value={
                                  selectedreportingGroup
                                  }
                                  textField={"EnumName"}
                                  valueField={"EnumValue"}
                                  data={reportingGroup}
  
                                  onChange={ReportingGroupddChange}
                              />
                        </div>
                      </div>
                <div className="my-4" >
                  <label className="label">Notes	</label>
                  <div>
                    <textarea style={{ marginLeft: "2%" }} id="txtStrategydesc" className="form-control" rows={7} onChange={NotesChange}
                      defaultValue={
                        Marketdatadetails.IndexNotes
                          ? Marketdatadetails.IndexNotes
                          : ""}
                    >
                    </textarea>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 d-flex justify-content-lg-end p-0 align-items-center">
                <button className="s-sm-btn mx-1" onClick={cancelnavigate} > Cancel</button>
                <button className='p-sm-btn mx-1' onClick={editMarketDataDetails} disabled={!isEditable}>Update</button>
                <button className='p-sm-btn mx-1' onClick={DeleteModalShow} disabled={!isEditable}>Delete</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showdeleteModal}  >
        <Modal.Header closeButton onClick={closedeleteModal}>
          <Modal.Title>Do you want to delete the  Market?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>The Market will be deleted permanently. Are you sure?</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="s-sm-btn mx-1" onClick={closedeleteModal} > Cancel</button>
          <button className='p-sm-btn mx-1' onClick={DeleteMarketData} >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
      <ToastContainer></ToastContainer>
    </div>

  );
}